import { SearchTool } from './SearchTool';
import { Address } from '../../Address';
import { Coords } from '../../Coords';
function formatAddress(addressData) {
    const houseNumber = addressData.house_number || '';
    const road = addressData.road || '';
    const postcode = addressData.postcode || '';
    const city = addressData.city || addressData.town || addressData.village || addressData.hamlet || '';
    const parts = [];
    if (houseNumber || road)
        parts.push(`${houseNumber} ${road}`.trim());
    if (postcode)
        parts.push(postcode);
    if (city)
        parts.push(city);
    return parts.join(' ');
}
export async function nominatimSearchFunction(query, options) {
    const url = new URL("https://nominatim.openstreetmap.org/search");
    url.searchParams.set("q", query);
    url.searchParams.set("format", "json");
    url.searchParams.set("addressdetails", "1");
    url.searchParams.set("limit", "5");
    const response = await fetch(url.toString(), {
        headers: {
            "Accept": "application/json",
            "User-Agent": "GgoMyNetwork/1.0 (galigeo.com)"
        },
        signal: options?.signal ?? null
    });
    const json = await response.json();
    if (!json || json.length === 0)
        return [];
    return json.map((r) => {
        const addressObj = new Address(formatAddress(r.address), r.address.postcode || '', r.address.city || r.address.town || r.address.village || r.address.hamlet || '');
        return {
            coords: new Coords(parseFloat(r.lat), parseFloat(r.lon)),
            score: parseFloat(r.importance) || 1,
            address: addressObj
        };
    });
}
export class NominatimSearchTool extends SearchTool {
    constructor() {
        super('Nominatim', nominatimSearchFunction);
    }
}
//# sourceMappingURL=NominatimSearchTool.js.map